<template>
  <div class="devpage-page">
    <van-pull-refresh v-model="isLoading" @refresh="onReflash" class="devpage-index">
      <div v-if="devdata">
        <van-nav-bar left-arrow class="crystal-nav" @click-right="devconfigshow = true" @click-left="gotohome">
          <template #left>
            <van-icon name="arrow-left" size="20px" color="#475569" />
          </template>
          <template #right>
            <van-icon name="setting-o" size="20px" color="#94a3b8" />
          </template>
          <template #title>
            <div class="nav-title-wrap">
              <span class="nav-devname">{{ devdata.udname }}</span>
              <span class="nav-did">{{ did }}</span>
            </div>
          </template>
        </van-nav-bar>

        <van-action-sheet v-model="devconfigshow" :actions="actions" cancel-text="取消" @select="onSelect"
          :title="devdata.udname" class="crystal-actionsheet" />

        <DevGroup v-if="devgroupcard" :did="devdata.did" @configstatus="configstatus($event)"></DevGroup>
        <DevName v-if="devnamecard" :did="devdata.did" @configstatus="configstatus($event)"></DevName>
        <DevUnbind v-if="devunbindcard" :did="devdata.did" @configstatus="configstatus($event)"></DevUnbind>

        <div class="status-block" :class="devdata.value.leak == 1 ? 'status-block--alarm' : 'status-block--normal'">
          <div class="status-inner">
            <span class="iconfont icon-bushuitubiao status-icon"></span>
            <div class="status-text">
              {{ devdata.value.leak == 1 ? '检测到漏水' : '水位正常' }}
            </div>
            <div class="status-sub">
              输出{{ devdata.action.o1 == 1 ? '已开启' : '已关闭' }}
            </div>
          </div>
        </div>

        <div class="content-area">
          <div class="info-card">
            <div class="info-item">
              <div class="info-item-left">
                <span class="iconfont icon-zidong1 info-icon" style="color: #2dd4bf"></span>
                <span class="info-label">电源开关</span>
              </div>
              <van-switch :value="devdata.action.o1 == 1" size="20" :loading="output_loading" :disabled="output_loading" @change="onOutputChange" />
            </div>
            <div class="info-divider"></div>

            <div class="info-item">
              <div class="info-item-left">
                <span class="iconfont icon-bushuitubiao info-icon" style="color:#2dd4bf"></span>
                <span class="info-label">水位状态</span>
              </div>
              <span :class="devdata.value.leak == 1 ? 'value-danger' : 'value-normal'">
                {{ devdata.value.leak == 1 ? '检测到漏水' : '水位正常' }}
              </span>
            </div>
            <div class="info-divider"></div>

            <div class="info-item">
              <div class="info-item-left">
                <span class="iconfont icon-gongzuomoshi info-icon" style="color:#2dd4bf"></span>
                <span class="info-label">工作模式</span>
              </div>
              <span class="value-normal">{{ work_mode === 1 ? '手动控制' : '自动保护' }}</span>
            </div>
            <div class="info-divider"></div>

          </div>

          <div class="info-card">
            <div class="info-item info-item--link" @click="gotolog()">
              <div class="info-item-left">
                <span class="iconfont icon-rizhi info-icon" style="color:#2dd4bf"></span>
                <span class="info-label">历史记录</span>
              </div>
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M6 4L10 8L6 12" stroke="#94a3b8" stroke-width="1.5" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </div>
            <div class="info-divider"></div>
            <div class="info-item info-item--link" @click="gotoconfig()">
              <div class="info-item-left">
                <span class="iconfont icon-sinaweibo18 info-icon" style="color:#2dd4bf"></span>
                <span class="info-label">参数设置</span>
              </div>
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M6 4L10 8L6 12" stroke="#94a3b8" stroke-width="1.5" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </div>
          </div>

        </div>
      </div>
    </van-pull-refresh>
  </div>
</template>

<script>
import DevGroup from "../general/apidevgroup.vue";
import DevName from "../general/apidevname.vue";
import DevUnbind from "../general/apidevunbind.vue";

export default {
  name: "DevPageKA1",
  components: {
    DevGroup,
    DevName,
    DevUnbind,
  },
  data() {
    return {
      auto_recovery: false,
      output_loading: false,
      work_mode: 0,
      leak_speed: 0,

      connection: {
        url: "wss://dev.kudutech.cn/mqtt",
        clean: true,
        clientId: this.$route.query.did + this.generateUUID(),
        username: "KA-1web",
        password: "KA-1web",
      },
      subscription: {
        topic: "kd/dev/KA-1/" + this.$route.query.did + "/push",
        qos: 1,
      },
      client: {
        connected: false,
      },

      devconfigshow: false,
      devgroupcard: false,
      devnamecard: false,
      devunbindcard: false,

      isLoading: false,

      devdata: null,
      did: this.$route.query.did,
      actions: [
        { name: "更改分组", color: "#2dd4bf" },
        { name: "重命名", color: "#2dd4bf" },
        { name: "解绑", color: "#fb7185" },
      ],
    };
  },
  mounted() {
    this.GetDevData(this.did);
    this.createConnection();
    this.doSubscribe();
  },
  beforeDestroy() {
    if (this.client.connected) {
      try {
        this.client.end();
        this.client = { connected: false };
      } catch (error) { }
    }
  },
  methods: {
    generateUUID() {
      var d = new Date().getTime();
      if (window.performance && typeof window.performance.now === "function") {
        d += performance.now();
      }
      var uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g, function (c) {
          var r = (d + Math.random() * 16) % 16 | 0;
          d = Math.floor(d / 16);
          return (c == "x" ? r : (r & 0x3) | 0x8).toString(16);
        }
      );
      return uuid;
    },
    createConnection() {
      const { url, ...options } = this.connection;
      try {
        if (!this.client.connected) {
          this.client = mqtt.connect(url, options);
        }
      } catch (error) { }
      this.client.on("connect", () => { console.log("Connection succeeded!"); });
      this.client.on("error", (error) => { });
      this.client.on("message", (topic, message) => {
        var datastr = `${message}`.replace(/\'/g, '"');
        this.resolve_data(JSON.parse(datastr));
      });
    },
    doSubscribe() {
      try {
        const { topic, qos } = this.subscription;
        this.client.subscribe(topic, qos, (error, res) => {
          if (error) return;
        });
      } catch (error) {
        console.warn("MQTT subscribe failed:", error);
      }
    },
    resolve_data(data_buf) {
      console.log("mqtt接收: ", data_buf);
      if (data_buf["m_type"] === "push") {
        this.devdata.action = data_buf.action;
        this.devdata.value = data_buf.value;
        this.devdata.err = data_buf.err;
        this.devdata.config = data_buf.config;
        this.auto_recovery = this.devdata.config.auto_recovery == 1;
        this.work_mode = this.devdata.config.work_mode != null ? this.devdata.config.work_mode : 0;
        this.leak_speed = this.devdata.config.leak_speed != null ? this.devdata.config.leak_speed : 0;
        this.$forceUpdate();
      }
    },
    change_auto_recovery() {
      this.send_config({ auto_recovery: this.auto_recovery ? 1 : 0 });
    },
    onOutputChange(val) {
      this.output_loading = true;
      this.send_config({ output: val ? 1 : 0 });
    },
    send_config(data) {
      const qs = require("qs");
      var databuf = JSON.stringify(data);
      this.$axios
        .post("/api/dev/easy_mqtt_config", qs.stringify({
          did: this.devdata.did,
          d_type: "KA-1",
          config: databuf,
        }))
        .then((response) => {
          this.output_loading = false;
          this.GetDevData(this.did);
          if (response.data.error_code != 0) {
            this.$notify({ type: "danger", message: "设置失败！" });
          } else {
            this.$notify({ type: "success", message: "设置成功！" });
          }
        })
        .catch((error) => {
          this.output_loading = false;
          this.GetDevData(this.did);
          this.$notify({ type: "danger", message: "设置失败！" });
        });
    },
    devrefresh() {
      this.isLoading = true;
      const qs = require("qs");
      var databuf = JSON.stringify({ a: 2 });
      this.$axios
        .post("/api/dev/easy_mqtt_config", qs.stringify({
          did: this.devdata.did,
          d_type: "KA-1",
          config: databuf,
        }))
        .then((response) => {
          this.isLoading = false;
          if (response.data.error_code === 0) {
            this.GetDevData(this.did);
          }
        })
        .catch((error) => { this.isLoading = false; });
    },
    onSelect(item) {
      this.devconfigshow = false;
      if (item.name === "重命名") { this.devnamecard = true; }
      else if (item.name === "更改分组") { this.devgroupcard = true; }
      else if (item.name === "解绑") { this.devunbindcard = true; }
    },
    configstatus(statu) {
      this.devgroupcard = false;
      this.devnamecard = false;
      this.devunbindcard = false;
      this.GetDevData(this.did);
      if (statu === true) { this.$toast.success("设置成功"); }
    },
    GetDevData(did) {
      const qs = require("qs");
      this.$axios
        .post("/api/dev/one", qs.stringify({ did: did }))
        .then((response) => {
          if (response.data.error_code === 0) {
            this.isLoading = false;
            this.devdata = response.data;
            this.auto_recovery = this.devdata.config.auto_recovery == 1;
            this.work_mode = this.devdata.config.work_mode != null ? this.devdata.config.work_mode : 0;
            this.leak_speed = this.devdata.config.leak_speed != null ? this.devdata.config.leak_speed : 0;
          } else if (response.data.error_code === 301) {
            this.$router.push({ path: "/login", name: "login" });
          } else {
            this.$router.push({ path: "/devlist" });
          }
        });
    },

    onReflash() { this.devrefresh(); },
    gotohome() { this.$router.go(-1); },
    gotoconfig() { this.$router.push({ name: "KA1Config", query: { did: this.did } }); },
    gotolog() { this.$router.push({ name: "KA1Log", query: { did: this.did, udname: this.devdata.udname } }); },
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=Noto+Sans+SC:wght@400;500;600;700&display=swap");

.crystal-nav {
  background: #ffffff !important;
  border-bottom: 1px solid #f1f5f9;
}

.crystal-nav .van-nav-bar__title {
  max-width: 70%;
}

.nav-title-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  line-height: 1.3;
}

.nav-devname {
  font-size: 16px;
  font-weight: 600;
  color: #1e293b;
}

.nav-did {
  font-size: 11px;
  color: #94a3b8;
}

.crystal-actionsheet .van-action-sheet__header {
  font-size: 15px;
  font-weight: 600;
  color: #1e293b;
}

</style>

<style scoped>
.devpage-page {
  min-height: 100vh;
  min-height: 100dvh;
  background: linear-gradient(145deg, #f0f9ff 0%, #fdf2f8 35%, #f0fdf4 100%);
  font-family: "Inter", "Noto Sans SC", sans-serif;
}

.devpage-index {
  background: transparent !important;
  padding-bottom: 20px;
  min-height: 100vh;
  min-height: 100dvh;
}

.status-block {
  margin: 12px 12px 0;
  border-radius: 18px;
  padding: 48px 24px;
  text-align: center;
  box-shadow: 0 2px 16px rgba(0, 0, 0, 0.04);
}

.status-block--normal {
  background: linear-gradient(135deg, #2dd4bf, #14b8a6);
  color: #fff;
}

.status-block--alarm {
  background: linear-gradient(135deg, #fb7185, #f43f5e);
  color: #fff;
}

.status-inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

.status-icon {
  font-size: 100px;
  line-height: 1.2;
  opacity: 0.9;
}

.status-text {
  font-size: 18px;
  font-weight: 600;
}

.status-sub {
  font-size: 13px;
  font-weight: 400;
  opacity: 0.8;
  margin-top: 2px;
}

.content-area {
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.info-card {
  background: #ffffff;
  border-radius: 18px;
  box-shadow: 0 2px 16px rgba(0, 0, 0, 0.04), 0 8px 24px rgba(0, 0, 0, 0.04);
  overflow: hidden;
}

.info-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  min-height: 24px;
}

.info-item--link {
  cursor: pointer;
  transition: background 0.15s;
}

.info-item--link:active {
  background: #f8fafc;
}

.info-item-left {
  display: flex;
  align-items: center;
  gap: 8px;
}

.info-icon {
  font-size: 17px;
  flex-shrink: 0;
}

.info-label {
  font-size: 14px;
  font-weight: 500;
  color: #475569;
}

.info-divider {
  height: 1px;
  background: #f1f5f9;
  margin: 0 16px;
}

.info-btn {
  height: 32px;
  padding: 0 16px;
  border: none;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  font-family: inherit;
  transition: transform 0.15s;
}

.info-btn:active {
  transform: scale(0.95);
}

.info-btn--primary {
  background: rgba(45, 212, 191, 0.15);
  color: #0d9488;
}

.info-btn--danger {
  background: #fb7185;
  color: #fff;
}

.value-normal {
  font-size: 14px;
  font-weight: 500;
  color: #475569;
}

.value-danger {
  font-size: 14px;
  font-weight: 500;
  color: #fb7185;
}

:deep(.van-switch--on) {
  background: #2dd4bf !important;
}
</style>
